import { SpacingOptions } from '@mui/system';

const spacing: SpacingOptions = 4;

export default spacing;
